import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import useDebounce from 'modules/common/hooks/useDebounce';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import CreateModal from '../components/CreateModal';
import UpdateModal from '../components/UpdateModal';
import OrdinanceRevisionContent from './OrdinanceRevisionContent';

const form = {
  q: '',
};

function OrdinanceRevisionContainer({
  match,
  history,
  getOrdinanceRevisionList,
  ordinanceRevisionList,
  isLoading,
  ordinanceRevisionListPager,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <CreateModal
          latestYear={_.get(ordinanceRevisionList, '0.attributes.year_from')}
        />
      ),
      title: 'Add Ordinance Revision',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update Ordinance Revision',
      modalSize: 'modal-md',
    });
  };

  useEffect(() => {
    getOrdinanceRevisionList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.q,
    sort_by: 'asc',
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getOrdinanceRevisionList({ q: formData.q, sort_by: 'desc' });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <Route
      path={`${match.path}/:ordinanceRevisionId?`}
      render={({ match: { params } }) => (
        <GenericListPair
          moduleName="Ordinance Revision"
          getData={getOrdinanceRevisionList}
          setParams={param}
          setKeyword={handleOnChange}
          keyword={_.get(formData, 'q') || ''}
          keywordPlaceholder="Search..."
          pathName={`${match.path}/:ordinanceRevisionId?`}
          listName="ordinanceRevision"
          label="Ordinance Revision"
          renderItem={(item) => (
            <div className="p-3">{_.get(item, 'attributes.name')}</div>
          )}
          isLoading={isLoading}
          selected={params.ordinanceRevisionId}
          data={ordinanceRevisionList}
          dataPager={ordinanceRevisionListPager}
          handleSelectRow={(data) => {
            history.push(`${match.url}/${_.get(data, 'id')}`);
          }}
          renderContent={() => (
            <React.Fragment>
              <Switch>
                <Route
                  path={`${match.path}/:ordinanceRevisionId?`}
                  render={() => (
                    <OrdinanceRevisionContent
                      handleAddModal={handleAddModal}
                      handleEdit={handleEdit}
                      // handleRemove={handleRemove}
                    />
                  )}
                />
              </Switch>
              <Route
                path={`${match.path}/:ordinanceRevisionId?`}
                render={() =>
                  !params.ordinanceRevisionId &&
                  ordinanceRevisionList.length > 0 ? (
                    <Redirect
                      to={`${match.url}/${_.get(
                        ordinanceRevisionList,
                        '0.id'
                      )}`}
                    />
                  ) : null
                }
              />
            </React.Fragment>
          )}
        />
      )}
    />
  );
}

OrdinanceRevisionContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getOrdinanceRevisionList: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionList: PropTypes.instanceOf(Array).isRequired,
  ordinanceRevisionListPager: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  ordinanceRevisionList: _.get(api, `${c.GET_ORDINANCE_REVISION}.list`) || [],
  ordinanceRevisionListPager:
    _.get(api, `${c.GET_ORDINANCE_REVISION}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_ORDINANCE_REVISION) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(OrdinanceRevisionContainer);
